import DettagliBolla from "../sezioni/DettagliBolla";
import DettagliPagamento from "../sezioni/DettagliPagamento";
import AnagraficaCliente from "./AnagraficaCliente.js";
import ProdottiBollaUscita from "./ProdottiBollaUscita.js";


export default function CampiBollaUscita({
    inputs,
    errors,
    onChange ,
    modifica = false
}) {
    

    return(
        <div className="w-100">
            <AnagraficaCliente  onChange={onChange} value={inputs} errors={errors} modifica={modifica} />
            <DettagliBolla  onChange={onChange} inputs={inputs} errors={errors} bollaUscita={true} />
            {/* <DettagliPagamento  onChange={onChange} inputs={inputs} errors={errors} /> */}
            <ProdottiBollaUscita  onChange={onChange} inputs={inputs} errors={errors} />
        </div>
    )
}